import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { ToastType } from "../constants/toast-type";
import { BeneficiariesList, Beneficiary, BeneficiaryPayload, SaveBeneficiariesPortalCriteria, } from "../models/beneficiary";
import { ApiService } from "./api.service";
import { HelperService } from "./helper.service";
import { ToastService } from "./toast.service";

const controllerRoute = '/mybeneficiaries';

@Injectable()
export class BeneficiariesService {

    constructor(
        private apiService: ApiService,
        private helperService: HelperService,
        private toastService: ToastService,
    ) { }

    public beneficariesPaylodValidation(payload: BeneficiaryPayload): BeneficiaryPayload {
        const l_Payload: BeneficiaryPayload = new BeneficiaryPayload();

        let l_Error: string = '';
        let l_PrimaryTotal: number = 0;
        let l_ContingentTotal: number = 0;
        let l_HaveNoBeneficiaries: boolean = true;
        let l_HaveNoPrimaryBeneficiaries: boolean = true;
        let l_HaveContingentBeneficiaries: boolean = false;

        payload.beneficiaryList.forEach((beneficiary: Beneficiary) => {
            const l_Beneficiary: Beneficiary = this.helperService.convertObjectIntoObject(beneficiary, new Beneficiary());
            l_Beneficiary.percentage = beneficiary.tempPercentage;
            if (l_Beneficiary.isSelected) {
                let l_LineError: string = '';
                if (l_Beneficiary.isPrimary) {
                    l_PrimaryTotal += l_Beneficiary.percentage;
                } else if (l_Beneficiary.isContingent) {
                    l_HaveContingentBeneficiaries = true;
                    l_ContingentTotal += l_Beneficiary.percentage;
                } else {
                    l_LineError = `${l_LineError} Requires Primary or Contingent Selection.`;
                }
                if (!l_Beneficiary.percentage || l_Beneficiary.percentage === 0)
                    l_LineError = `${l_LineError} Requires Percentage.`;

                if (l_HaveNoPrimaryBeneficiaries && l_Beneficiary.isPrimary)
                    l_HaveNoPrimaryBeneficiaries = false;

                if (l_LineError)
                    l_Error = `${l_Beneficiary.firstName}: ${l_LineError}`;
                else
                    l_HaveNoBeneficiaries = false;
            }

            // Only send selected or existing beneficiaries to update. 
            // Although the records are deleted, still need to do the proper API checks
            if (l_Beneficiary.isSelected || l_Beneficiary.memberBenefitBeneficiaryID > 0)
                l_Payload.beneficiaryList.push(l_Beneficiary);
        });

        if (l_HaveNoPrimaryBeneficiaries || l_HaveNoBeneficiaries) {
            l_Error = 'There must be at least ONE Primary Beneficiary assigned to continue.';
        } else {
            if (l_PrimaryTotal != 100)
                l_Error = `Primary Beneficiaries total ${l_PrimaryTotal}% is not 100%.`;

            if (l_HaveContingentBeneficiaries && l_ContingentTotal != 100)
                l_Error = `Contingent Beneficiaries total ${l_ContingentTotal}% is not 100%.`;
        }

        if (l_Error) {
            this.toastService.buildToastMessage(ToastType.warning, 'Beneficiaries Error', l_Error);
            return null;
        }

        return l_Payload;
    }

    public getBeneficiaryList(): Observable<BeneficiariesList> {
        return this.apiService.get(`${controllerRoute}/beneficiary-list`).pipe(map((response: BeneficiariesList) => {
            return response;
        }));
    }

    /**
     * API only sends a 204
     * @param BeneficiaryPayload 
     */
    public setBeneficiaries(payload: BeneficiaryPayload): Observable<any> {
        return this.apiService.post(`${controllerRoute}/beneficiaries`, payload).pipe(map(() => {
            this.toastService.buildToastMessage(ToastType.success, 'Success', 'Beneficiaries Updated');
            return;
        }));
    }

    public saveBeneficiaries(payload: SaveBeneficiariesPortalCriteria): Observable<any> {
        return this.apiService.post(`${controllerRoute}/save-beneficiaries-portal`, payload).pipe(map(() => {
            this.toastService.buildToastMessage(ToastType.success, 'Success', 'Beneficiaries Updated');
            return;
        }));
    }

}